$(document).ready(function () {
    $('.password-validation').on('propertychange change keyup paste input', function () {

        // TODO: only use the first 128 characters to stop this from blocking the browser if a giant password is entered
        var password = $(this).val();
        var passwordScore = zxcvbn(password)['score'];

        console.log(password);
        var updateMeter = function (width, background, backgroundText, text) {
            $('.password-background').css({"width": width, "background-color": background});
            $('.strength').text('Síla hesla: ' + text).css('color', backgroundText);
        }

        if (passwordScore === 0) {
            if (password.length === 0) {
                updateMeter("0%", "#ffa0a0", "#a94442", "žádná");
            } else {
                updateMeter("20%", "#ffa0a0", "rgb(189, 107, 107)", "velmi slabé");
            }
        }
        if (passwordScore == 1) updateMeter("40%", "#ffb78c", "rgb(210, 118, 63)", "slabé");
        if (passwordScore == 2) updateMeter("60%", "#ffec8b", "rgb(189, 171, 77)", "střední");
        if (passwordScore == 3) updateMeter("80%", "#c3ff88", "rgb(122, 155, 90)", "silné");
        if (passwordScore == 4) updateMeter("100%", "#ACE872", "rgb(92, 132, 54)", "velmi silné");

    });

    // TODO: add ie 8/7 support, what browsers didnt support this check market share
    $('.show-password').click(function (event) {
        event.preventDefault();
        if ($('.password-validation').attr('type') === 'password') {
            $('.password-validation').attr('type', 'text');
            $('.show-password').text('Skrýt heslo');
        } else {
            $('#password').attr('type', 'password');
            $('.password-validation').text('Zobrazit heslo');
        }
    });

});